import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.components.AvailabilityEdit.title',
    defaultMessage: 'Edit availability',
  },
  failureMessage: {
    id: 'app.components.AvailabilityEdit.failureMessage',
    defaultMessage: 'Failed to edit availability',
  },
  successMessage: {
    id: 'app.components.AvailabilityEdit.successMessage',
    defaultMessage: 'Successfully edited availability',
  },
  back: {
    id: 'app.components.AvailabilityEdit.back',
    defaultMessage: 'Back to my availabilities',
  },
  takesEffectAfterDate: {
    id: 'app.components.AvailabilityEdit.takesEffectAfterDate',
    defaultMessage:
      'The change to the availability will be considered starting {date}.',
  },
});
